<style lang="scss" scoped>
.input-form {
  background-color: #eee;
  padding: 15px 15px 10px;
  margin: 0 0 10px;
  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.input-preview {
  pre {
    white-space: pre-wrap;
  }
}
</style>

<template>
  <div class="html-input">
    <div class="input-form" v-if="isEditing">
      <h2>HTML</h2>
      <div class="form-group">
        <textarea
          placeholder="HTML"
          class="form-control"
          name="html"
          cols="30"
          rows="5"
          v-model="html"
        ></textarea>
      </div>
      <div class="btn-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="input-preview" v-else>
      <pre>{{ html }}</pre>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';

export default {
  props: {
    value: {},
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      html: '',
    };
  },
  components: {
    'footer-menu': footerMenu,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          html: this.html,
        },
        action: 'html',
        id: this.id,
      };
    },
  },
  mounted() {
    this.html = this.value.html;
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>
